
import axios from "axios";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { DataItemProps } from ".";

interface ApiDataExportInputProps {
    formCode: string;
    page?: number;
    pageSize?: number;
    q?: string;
    statusIds?: number[];
    hasIds?: number[];
    [key: string]: any
}

export const apiDataExportByCode = async ({ formCode, ...data }: ApiDataExportInputProps) => {
    const res = (await axios.get(`/api/data/export-by-code/${formCode}/export`, { params: data, responseType: "blob", }));

    // Lấy tên file từ header nếu có
    const contentDisposition = res.headers["content-disposition"];
    let fileName = "export.xlsx";

    if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+?)"?$/);
        if (match?.[1]) fileName = match[1];
    }

    // Tạo blob download
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
    return res;
};

interface ApiDataExportByIdInputProps extends Omit<ApiDataExportInputProps, "formCode"> {
    formId: number;
}
export const apiDataExportById = async ({ formId, ...data }: ApiDataExportByIdInputProps, locale?: string) => {
    const res = (await axios.get(`/api/data/export-by-id/${formId}/export`, { params: data, responseType: "blob", }));

    // Lấy tên file từ header nếu có
    const contentDisposition = res.headers["content-disposition"];
    let fileName = "export.xlsx";

    if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+?)"?$/);
        if (match?.[1]) fileName = match[1];
    }

    // Tạo blob download
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
    return res;
};